import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const STEPS = [
  {
    n: "01",
    title: "Reach out",
    body: "Tap Get a Quote or call us. Tell us about your space and what you'd like cleaned.",
  },
  {
    n: "02",
    title: "We confirm the details",
    body: "We'll walk through the scope, timing, and any preferences so everything's set before we arrive.",
  },
  {
    n: "03",
    title: "We make it pretty",
    body: "We show up on time and clean to a standard we'd want in our own home — a pretty clean, every time.",
  },
];

export function HowItWorks() {
  return (
    <section className="px-4 py-14 md:px-6 md:py-24">
      <Reveal>
        <SectionHeading
          eyebrow="How It Works"
          title="Three easy steps to a pretty clean"
          intro="Simple, friendly, and straightforward — from first hello to a spotless space."
        />
      </Reveal>

      <div className="mx-auto mt-14 max-w-5xl">
        <div className="grid gap-10 md:grid-cols-3 md:gap-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 90} className="relative text-center md:text-left">
              {/* dotted connector */}
              {i < STEPS.length - 1 && (
                <span
                  className="pointer-events-none absolute -right-3 top-6 hidden h-px w-6 bg-[repeating-linear-gradient(90deg,var(--color-primary),var(--color-primary)_3px,transparent_3px,transparent_7px)] md:block"
                  aria-hidden
                />
              )}
              <div className="flex items-center gap-3 md:flex-col md:items-start md:gap-2">
                <span className="font-script text-4xl leading-none text-primary md:text-5xl">
                  {s.n}
                </span>
                <h3 className="text-xl font-bold text-ink">{s.title}</h3>
              </div>
              <p className="mt-3 text-muted-foreground text-pretty md:max-w-[16rem]">{s.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
